import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Button,
    Divider,
    Table,
    Snackbar,
    TableBody,
    TableRow,
    TableCell,
    Switch,
    colors,
    TableHead
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import SaveIcon from '@material-ui/icons/Save';

// import axios from '../../config/axios';
import { useTheme } from '@material-ui/core/styles';
import DetailData from '../../pages/DetailAdmin/components/DetailData';
import { classBody } from '@babel/types';
import { get_admin_details, edit_admin_property } from '../../api/API';

//const theme = useTheme();
const useStyles = makeStyles(() => ({
    root: {
        padding: '24px',
    },
    leftIcon: {
        //   marginRight: theme.spacing.unit,
    },

}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  
export default class DetailAdmin extends React.Component {

    constructor(props) {
        super(props);
        // console.log( this.props.match );

        this.state = {
            admins: null,
            admin_id: props.admin_id,
            toast: false
        }
    }

    async get_data() {
        const postparam = {
            admin_id: this.state.admin_id
        };

        var json = await get_admin_details(postparam);
        if (json.status) {

            let agencies = {};
            for (let i = 0; i < json.data.property.length; i++) {
                agencies['property_' + json.data.property[i].property_id] = parseInt(json.data.property[i].can_edit) > 0
            }
            this.setState({
                ...this.state,
                values: {
                    admin_id: this.state.admin_id,
                    ...agencies
                },
                admins: json.data,
                has_edited: false
            });
        }
    }

    refresh() {
        this.get_data();
    }
    componentDidMount() {
        this.get_data();
    }

    handleChange(e) {
        console.log(e.target.name, e.target.checked);
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [e.target.name]: e.target.checked,
            },
            has_edited: true
        }, () => {
            this.submitForm();
        });
    }

    async submitForm() {
        console.log(this.state.values);
        let data = await edit_admin_property(this.state.values);
        if (data) {
            this.setState({
                ...this.state,
                toast: true,
                has_edited: false
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                <Grid
                    {...this.props}
                    className={clsx(this.props.classes.root, this.props.className)}
                    container
                    spacing={1}
                    style={{
                        flexDirection: "row"
                    }}
                >
                    <Grid
                        item
                        lg={6}
                        md={6}
                        xl={4}
                        xs={12}
                    >
                        {this.state.admins ?
                            <DetailData
                                {...this.props}
                                refresh={this.refresh.bind(this)}
                                classes={this.props.classes} admins={this.state.admins} /> : ''
                        }
                    </Grid>
                    {this.state.admins && this.state.admins.role_id == "2" ?
                        <Grid
                            item
                            lg={6}
                            md={6}
                            xl={4}
                            xs={12}
                        >
                            <Card>
                                <CardHeader title="Showrooms"

                                ></CardHeader>
                                <CardContent>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Showroom Name</TableCell>
                                                <TableCell>Can Edit</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {this.state.admins.property.map((property) => (
                                            <TableRow>
                                                <TableCell>{property.name}</TableCell>
                                                <TableCell>
                                                    <Switch
                                                        checked={this.state.values['property_' + property.property_id]}
                                                        color="primary"
                                                        onChange={this.handleChange.bind(this)}
                                                        name={"property_" + property.property_id}
                                                    ></Switch>
                                                </TableCell>
                                            </TableRow>
                                        ))}

                                    </Table>
                                </CardContent>
                                <CardActions style={{
                                    justifyContent: "flex-end",
                                    alignItems: "flex-end"
                                }}>
                                    {/* {this.state.has_edited &&
                                    (<Button
                                        onClick={this.submitForm.bind(this)}
                                        variant="contained"
                                    >
                                        <SaveIcon className={this.props.classes.leftIcon} />
                                    Save Changes
                                    </Button>)} */}
                                </CardActions>
                            </Card>
                        </Grid> : ''}
                </Grid>
                <Snackbar open={this.state.toast} autoHideDuration={2000} onClose={()=>{
                    this.setState({
                        ...this.state,
                        toast: false
                    });
                }}>
                    <Alert onClose={()=>{
                    this.setState({
                        ...this.state,
                        toast: false
                    }) }
                    } severity="success">
                        Updated
                </Alert>
                </Snackbar>
            </React.Fragment>
        )
    }
}




